/**
 * One round: send the queue, then learn what changed. In that order, so the
 * changes that come down already hold the writes that went up.
 */

import { refresh } from "./cache";
import { announce, drain, type Drained } from "./outbox";

/** The Background Sync tag: the page asks for it, the Service Worker answers it. */
export const SYNC_TAG = "kindred-outbox";

export interface Synced extends Drained {
  /** The cache was dropped (rule 5's reset): the caller fetches whole. */
  reset: boolean;
}

export async function sync(db: IDBDatabase, fetcher: typeof fetch): Promise<Synced> {
  const drained = await drain(db, { fetch: fetcher });
  if (drained.held) return { ...drained, reset: false };
  const refreshed = await refresh(db, fetcher);
  // The rows may have changed: an open widget reads them again (`useCached`).
  if (refreshed) announce("cache");
  return { ...drained, reset: refreshed?.reset ?? false };
}
